// @flow
import React from 'react'
import Switch from '@material-ui/core/Switch'
import ErrorBoundary from 'catena/er2_map_userlayers/js/components/error_boundary'
import styles from '../styles'
import type { CollaborationType } from '../reducers/collaboration'
import stylesFicus from '../styles/ficus_style'

type CollaborationSettingsPropsType = {
    updateSettings: Function,
    settings: CollaborationType,
    theme: styles,
}

class CollaborationSettings extends React.Component<CollaborationSettingsPropsType> {
    constructor(props) {
        super(props)
        this.state = {
            boundingBox: false,
            locations: false,
            analyzeMode: false,
            framework: false,
            readOnly: false,
        }
    }

    render() {
        const containerStyle = { padding: '6px 10px' }

        const panelData = [
            { pdText: 'Map Extent Changes', pdKey: 'boundingBox', pdHelp: 'Follow map extent changes in other windows within the same session.' },
            { pdText: 'Location Selections', pdKey: 'locations', pdHelp: 'Show location selection popup (mouse click in map) of other windows in the same session.' },
            { pdText: 'Analysis Brushing', pdKey: 'analyzeMode', pdHelp: 'Follow switching between "Quartiles", "Realization", and "Others" in other windows of the same session.' +
                ' Also react to analysis chart updates and changes to the ordering or current frame.' },
            { pdText: 'Theme Changes', pdKey: 'framework', pdHelp: 'Follow other windows if a new theme is loaded. The same theme will show in this window.' },
        ]

        return (
            <ErrorBoundary>
                <div>
                    {panelData.map(({ pdText, pdKey, pdHelp }) => (
                        <div style={containerStyle} key={pdKey}>
                            <span className={this.props.theme.collaborationLabel}>{pdText}</span>
                            <Switch
                                checked={this.props.settings[pdKey]}
                                color="secondary"
                                onChange={e => this.props.updateSettings({ [pdKey]: !this.props.settings[pdKey] })}
                            />
                            <span
                                className={`fa fa-question-circle-o ${this.props.theme.helpIcon}`}
                                onClick={() => this.setState({ [pdKey]: !this.state[pdKey] })}
                                role={'button'}
                                tabIndex={-1}
                            />
                            {this.state[pdKey] && (
                                <div className={this.props.theme.help}>{pdHelp}</div>
                            )}
                        </div>
                    ))}
                </div>
            </ErrorBoundary>
        )
    }
}

export default CollaborationSettings
